import React from 'react';

import * as S from './salary-provided-header.styles';

type Props = {
  headlineCopy: string;
};

export const SalaryProvidedHeader: React.VFC<Props> = ({ headlineCopy }) => {
  return (
    <S.Wrapper>
      <S.Header>
        <S.Headline size="xlarge">{headlineCopy}</S.Headline>
      </S.Header>
    </S.Wrapper>
  );
};
